import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import lifecycle from './lifecycle/lifecycle.routes';
import generalInfo from './generalInfo/generalInfo.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import captain from './captain/captain.routes';
import aiAssist from './aiAssist/aiAssist.routes';
import aiPrompts from './aiPrompts/aiPrompts.routes';
import aiKnowledgeSource from './aiKnowledgeSource/aiKnowledgeSource.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/users/list'),
      redirect: to => ({
        name: 'agent_list',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/users'),
      redirect: to => ({
        name: 'agent_list',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          ['administrator', 'owner'].includes(store.getters.getCurrentRole) &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_info_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      redirect: to => ({
        name: 'general_info_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/ai-agents'),
      redirect: to => ({
        name: 'ai_agents',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/ai-agents/new'),
      redirect: to => ({
        name: 'ai_agents_templates',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/ai-agents/:id/edit'),
      redirect: to => ({
        name: 'ai_agents_edit',
        params: { accountId: to.params.accountId, id: to.params.id },
      }),
    },
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...canned.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...lifecycle.routes,
    ...generalInfo.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...conversationWorkflow.routes,
    ...captain.routes,
    ...aiAssist.routes,
    ...aiPrompts.routes,
    ...aiKnowledgeSource.routes,
  ],
};
